<template>
  <div>
    <router-view name="mainLayout" key="mainLayout"></router-view>
    <router-view name="wavveon" key="wavveonLayout"></router-view>
    <router-view name="member" key="member"></router-view>
    <router-view name="adult" key="adult"></router-view>
    <router-view name="voucher_popup" key="voucher_popup"></router-view>
    <router-view name="callback" key="callback"></router-view>
    <router-view name="construction" key="construction"></router-view>
    <router-view name="event_emergency" key="event_emergency"></router-view>
    <router-view name="notfound" key="notfound"></router-view>
    <router-view name="waiting" key="waiting"></router-view>
    <EventProcessor/>
  </div>
</template>
<script>
import EventProcessor from '@/components/EventProcessor'
export default {
  components: { EventProcessor }
}
</script>
<style lang="css" src="@/assets/css/common.css"></style>
<style lang="css" src="@/assets/css/base.css"></style>
<!--<style lang="css" src="@/assets/css/main.css"></style>-->
<!--<style lang="css" src="@/assets/css/mypooq.css"></style>-->
